import React, { useState, useEffect } from "react";
import {
  Form,
  Select,
  Button,
  Row,
  Col,InputNumber,
  notification,
  message
} from "antd";
import {
  PlusOutlined
} from "@ant-design/icons";
import { getVehiclesActiveApi} from "../../../../api/user";
import {put} from "../../../../api/put";
import { getAccessTokenApi } from "../../../../api/auth";
import { get } from "../../../../api/get";
import "./EditHubsForm.scss";

export default function EditHubsFormVehicles(props) {
  const { hub, setIsVisibleModal, setReloadHubs } = props;
  var hubb=hub
  const [vehiclesActive, setVehiclesActive] = useState([]);
  const [huba, sethuba] = useState(hub);
  const [vehiclesActiveData, setVehiclesActiveData] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [selectednumber, setSelectednumber] = useState(0);
  const [auxis, setauxis] = useState('');
  const [a, setA] = useState(true);
  const { Option } = Select;

  
  useEffect(() => {
    hubb=hub
    sethuba(hub)
    // console.log(hubb,'==');
    // console.log(hub,'========');
    // console.log(huba,'===============');
    const token = getAccessTokenApi();
    get(`vehicles-active?active=${true}`,'vehicles-active','').then((response) => {
    // getVehiclesActiveApi(token, true).then((response) => {
      // console.log(response)
      const vehicles = response.vehicles;
      // console.log(vehicles)

      var auxi=[]
      var auxiliar=[]
      for (let i = 0; i < hubb.hubvehicles.length; i++) {
        var name=''
        var type=''
        for (let j = 0; j < vehicles.length; j++) {
          if(hubb.hubvehicles[i].uid==vehicles[j]._id){
            name=vehicles[j].name
            type=vehicles[j].types
          }
        }
        auxi.push(
          <Form.Item>
            <Row gutter={24}>
              <Col span={16}>
                <InputNumber
                  addonBefore={name}
                  addonAfter={type}
                  name='veh'
                  min={0}
                  max={999999}
                  step={1}
                  style={{
                    margin: '0px 0px 0px 0px',
                  }}
                  value={hubb.hubvehicles[i].number} 
                  onChange={(e) => 
                    {
                      // hub.hubvehicles[i].number=e
                      var aux = hubb
                      aux.hubvehicles[i].number=e
                      // console.log(aux)
                      sethuba(aux)
                      setA(!a)
                    }
                  }
                />
              </Col>
              <Col span={8}>
                <Button type="primary" style={{
                    backgroundColor:'white',
                    borderWidth:'2px',
                    fontSize:'15px',
                    color:'rgb(0,104,178)'
                  }} 
                  onClick={async () => {
                    var aux = hubb
                    // console.log(aux,'antes',i)
                    aux.hubvehicles.splice(i,1)
                    // console.log(aux,'despues')
                    sethuba(aux)
                    setA(!a)
                  }}
                  >
                  Delete vehicle
                </Button>
              </Col>
            </Row>
          </Form.Item>
        )
        auxiliar.push({
          uid: hubb.hubvehicles[i].uid,
          number: hubb.hubvehicles[i].number,
        })
      }
      // console.log(auxiliar,'........')
      // setVehiclesActiveData(auxiliar)
      setauxis(auxi)
      // setA(prevA => prevA + 1);
      // seta(!a)
    })
  }, [hub,a]);
  // }, [seta,a]);

  const updateHub = (e) => {
    var checker=false
    for (let i = 0; i < hubb.hubvehicles.length; i++) {
      // console.log('===============')
      // console.log(hubb)
      // console.log('=====')
      // console.log(hub)
      // console.log('=')
      if(hubb.hubvehicles[i].uid===selectedVehicle){
        checker=true
      }
    }
    // if(selectedVehicle.length>1)checker=true
    
    if(checker){
      // notification["error"]({
      //   message: `Change the vehicle type added to another.`,
      //   // description:messag
      // });
      message.error( `Change the vehicle type added to another.`)
    }else if(selectedVehicle.length===undefined||selectedVehicle.length<1){
      // setIsVisibleModal(false);
      //   setReloadHubs(true);
      //   setVehiclesActive([])
      //   setVehiclesActiveData([])
      //   setSelectedVehicle('')
      //   setSelectednumber(0)
      //   setA(!a);
        message.error( `Add a vehicle to update.`)
    }else if(selectedVehicle.length<2&&hubb.hubvehicles.length>0){
      const token = getAccessTokenApi();
      // console.log(huba,'000000000000000000000')
      put(hubb,'update-hub','update-hub',`/${hubb.name}` ).then((result) => {
      // updateHubApi(token, hubb, hubb.name).then((result) => {
        // notification["success"]({
        //   message: 'Changes saved!',
        // });
        message.success( 'Changes saved!')
        setIsVisibleModal(false);
        setReloadHubs(true);
        setVehiclesActive([])
        setVehiclesActiveData([])
        setSelectedVehicle('')
        setSelectednumber(0)
        setA(!a);
      });
    }else{
      // var types=''
      // for (let i = 0; i < vehiclesActiveData.length; i++) {
      //   if(vehiclesActiveData[i]._id===selectedVehicle){
      //     types=vehiclesActiveData[i].types
      //   }
      // }
      var aux = hubb
      aux.hubvehicles.push({
        uid: selectedVehicle,
        // types: types,
        number: selectednumber,
      })
      e.preventDefault();
      // console.log(aux)
      const token = getAccessTokenApi();
      put(aux,'update-hub','update-hub',`/${hubb.name}` ).then((result) => {
      // updateHubApi(token, aux, hubb.name).then((result) => {
        // notification["success"]({
        //   message: 'Changes saved!',
        // });
        message.success( 'Changes saved!')
        setIsVisibleModal(false);
        setReloadHubs(true);
        setVehiclesActive([])
        setVehiclesActiveData([])
        setSelectedVehicle('')
        setSelectednumber(0)
        setA(!a);
      });
    }
  };

  async function addVehicle() {
    const token = getAccessTokenApi();
    const vehiclesResponse = await  get(`vehicles-active?active=${true}`,'vehicles-active','')
    const vehicles = vehiclesResponse.vehicles;
    console.log(vehicles)
    
    if(vehiclesActive.length>=1){
      // notification["error"]({
      //   message: `You only are allowed to add vehicles one by one.`,
      //   // description:messag
      // });
      message.error( `You only are allowed to add vehicles one by one.`)
    }else if((hub.hubvehicles.length+vehiclesActive.length)<vehicles.length){
      const vehicless = vehicles.map(vehicle => <Option value={vehicle._id}>{vehicle.name}</Option>);
      
      const newRow = (
        <Row>
          <Col span={12}>
            <Form.Item>
              <Select 
              onChange={value => setSelectedVehicle(value)}
              placeholder="Tipo de vehículo">
                {vehicless}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <InputNumber
                min={0}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                defaultValue={0} 
                onChange={(e) => 
                  {
                    setSelectednumber(e)
                  }
                }
                />
            </Form.Item>
          </Col>
        </Row>
      );
      setVehiclesActiveData(vehicles)
      setVehiclesActive(prevVehicles => [...prevVehicles, newRow]);
    }else{
      // notification["error"]({
      //   message: `You have already added all types of vehicles.`,
      //   // description:messag
      // });
      message.error( `You have already added all types of vehicles.`)
    }
  }



  return (
  <Form className="form-edit" onSubmit={updateHub}>
      {auxis}
      {vehiclesActive}
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="btn-submit" onClick={updateHub}>
              Update vehicle
            </Button>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Button type="primary" style={{
            backgroundColor:'white',
            borderWidth:'2px',
            fontSize:'15px',
            color:'rgb(0,104,178)'
          }} 
          onClick={async () => {
            await addVehicle()
            // console.log(vehiclesActive,'jo')
          }}
          >
          <PlusOutlined  style={{color:'rgb(0,104,178)'}}/>
          Add vehicle
          </Button>
        </Col>
      </Row>
    </Form>
    );
}


